import { render, staticRenderFns } from "./Turno.vue?vue&type=template&id=2c4cb1b0&scoped=true&lang=pug&"
import script from "./Turno.vue?vue&type=script&lang=js&"
export * from "./Turno.vue?vue&type=script&lang=js&"
import style0 from "./Turno.vue?vue&type=style&index=0&id=2c4cb1b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4cb1b0",
  null
  
)

export default component.exports